import { Color } from "@bonliva-crm/ui";
import { LabelWithInfo } from "../label-with-info";

type HlrLabelProps = {
  qcName: string;
  label: React.ReactNode;
};

export function HlrLabel({ qcName, label }: HlrLabelProps) {
  return qcName !== "HLR" ? (
    <LabelWithInfo
      label={label}
      info={
        <span>
          När du skickar en beställning till KvK så går samtidigt ett autogenererat mail
          ut till konsulten som innehåller en länk till bokningssidan{" "}
          <a
            href={"www.boka.se/bonliva"}
            target={"_blank"}
            style={{ color: Color.PrimaryMain }}
          >
            www.boka.se/bonliva
          </a>{" "}
          och hur de går tillväga om de redan genomgått utbildning och har ett intyg.
        </span>
      }
    />
  ) : (
    label
  );
}
